"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Shield, Users, Zap } from "lucide-react";
export default function ProductsGrid() {
  const features = [{
    title: "Experiência Comprovada",
    description: "Somamos mais de duas décadas orientando líderes de níveis corporativos estratégicos em momentos de promoção, sucessão ou transição de carreira e novos empreendimentos.",
    icon: Shield
  }, {
    title: "Relevância de Mercado",
    description: "Orientamos a definição do posicionamento estratégico que leva em conta liderança e experiência profissional ao lado das oportunidades existentes e em expansão no mercado.",
    icon: Zap
  }, {
    title: "Conexões de Alto Nível",
    description: "Promovemos o acesso a um ambiente qualificado de networking entre líderes, executivos e profissionais, ampliando sinergias e o potencial de parcerias de negócio.",
    icon: Users
  }];
  return <section id="diferencial" className="relative overflow-hidden bg-background py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute top-1/2 left-1/2 h-[500px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-primary/5 blur-[120px]" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl">
          <span className="font-mono text-xs font-bold tracking-[0.3em] text-primary uppercase">
            O DIFERENCIAL MASTERPRO+
          </span>
          <h2 className="mt-6 font-serif text-4xl font-bold md:text-6xl text-foreground">
            Experiência. Relevância. Conexões.
          </h2>
          <p className="mt-8 font-default font-normal leading-relaxed text-muted-foreground md:text-xl">A MASTERPRO+ não é mais uma consultoria ou assessoria: é um ecossistema completo para você que já construiu uma trajetória de liderança e destaque e agora busca aprimorar seu posicionamento e perpetuar seu legado, sendo protagonista na continuidade de seu desenvolvimento profissional e pessoal.</p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {features.map((feature, i) => <div key={i} data-index={i} className="group relative rounded-lg border border-white/10 bg-card/40 p-8 backdrop-blur-md transition-all duration-500 hover:border-primary/50 hover:shadow-2xl hover:shadow-primary/5">
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary transition-transform duration-500 group-hover:scale-110">
                <feature.icon className="h-6 w-6" />
              </div>
              <h3 className="mb-4 font-serif text-2xl font-semibold text-foreground">
                {feature.title}
              </h3>
              <p className="font-default font-normal leading-relaxed text-muted-foreground">
                {feature.description}
              </p>
            </div>)}
        </div>

        <div className="mt-16 flex flex-wrap gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 py-6 font-sans font-bold uppercase tracking-widest text-xs">
            <Link to="https://wa.me/5511966187866" newTab>Solicitar Conexão Estratégica</Link>
          </Button>
        </div>
      </div>
    </section>;
}